import type {PermissionLevels, PermissionTreeItem} from '../typedef';

type GetLevel = (codes: string[], tree: PermissionTreeItem) => PermissionLevels;
export const getLevel: GetLevel = (codes: string[], tree) => {
    if (tree.code && codes.includes(tree.code)) {
        return tree.level;
    } else if (!tree.code) {
        return 0;
    } else {
        let nextLevel: PermissionLevels = 0;

        tree.children.forEach(child => {
            const level = getLevel(codes, child);
            if (level) {
                nextLevel = level;
            }
        });

        return nextLevel;
    }
};
